'use strict';

const base = require('integrations/product/base');
var siteIntegrations = require('integrations/integrations/siteIntegrationsUtils');
var toggleObject = siteIntegrations.getIntegrationSettings();
/**
 * Process the attribute values for an attribute that has image swatches
 *
 * @param {Object} attr - Attribute
 * @param {string} attr.id - Attribute ID
 * @param {Object[]} attr.values - Array of attribute value objects
 * @param {string} attr.values.value - Attribute coded value
 * @param {string} attr.values.url - URL to de/select an attribute value of the product
 * @param {boolean} attr.values.isSelectable - Flag as to whether an attribute value can be
 *     selected.  If there is no variant that corresponds to a specific combination of attribute
 *     values, an attribute may be disabled in the Product Detail Page
 * @param {jQuery} $productContainer - DOM container for a given product
 * @param {Object} msgs - object containing resource messages
 */
base.methods.processSwatchValues = function processSwatchValues(attr, $productContainer, msgs) {
    if (attr.attributeId == 'color') {
        $productContainer.find('.color-display-value').text(attr.displayValue || '');
    };

    if (attr.attributeId == 'size') {
        $productContainer.find('.non-color-display-value').text(attr.displayValue || '');
    };

    attr.values.forEach(function (attrValue) {
        var $attrValue = $productContainer.find('[data-attr="' + attr.id + '"] [data-attr-value="' + attrValue.value + '"]');

        var $swatchButton = $attrValue.parent('button');

        if (attrValue.selected) {
            $attrValue.addClass('selected');
            $attrValue.siblings('.selected-assistive-text').text(msgs.assistiveSelectedText);
            $attrValue.attr('selected', 'selected');
        } else {
            $attrValue.removeClass('selected');
            $attrValue.siblings('.selected-assistive-text').empty();
            $attrValue.removeAttr('selected');
        }

        if (attrValue.url) {
            $swatchButton.attr('data-url', attrValue.url);
            $swatchButton.data('url', attrValue.url);
        } else {
            $swatchButton.removeAttr('data-url');
            $swatchButton.data('url', null);
        }

        // Disable if not selectable
        $attrValue.removeClass('selectable unselectable available unavailable out-of-stock');

        $attrValue.addClass(attrValue.selectable && attrValue.available ? 'selectable' : 'unselectable');
        $attrValue.addClass(attrValue.available ? 'available' :  toggleObject.viewOutOfStockItems ? 'out-of-stock' : 'unavailable');

        if ($swatchButton.length) { // If the product is unavailable, apply the class to use the pseudoclass styling to the button for out of stock products,
            // otherwise remove the class from the button
            $swatchButton.addClass(!attrValue.available ? 'unavailable-product' : '');
            $swatchButton.attr('aria-disabled', !attrValue.available);
            $swatchButton.removeClass(attrValue.available ? 'unavailable-product' : '');

            if ($swatchButton.attr('aria-label')) {
                $swatchButton.attr('aria-label', $swatchButton.attr('aria-label').replace(' (' + msgs.unavailableVariantMsg + ')', ''))
                if (!attrValue.available) {
                    $swatchButton.attr('aria-label', $swatchButton.attr('aria-label') + ' (' + msgs.unavailableVariantMsg + ')')
                }
            }
        }

        $attrValue.attr('value', attrValue.url).removeAttr('disabled');
        if (!attrValue.selectable) {
            $attrValue.attr('disabled', true);
        }
    });
}


/**
 * Updates the Mini-Cart quantity value after the customer has pressed the "Add to Cart" button
 * @param {string} response - ajax response from clicking the add to cart button
 */
base.methods.handlePostCartAdd = function handlePostCartAdd(response) {
    // conditional added for response, sometimes it was failing when called on page load
    if (response) {
        $('.minicart').trigger('count:update', response);
        // show add to cart toast
        if (response.newBonusDiscountLineItem
            && Object.keys(response.newBonusDiscountLineItem).length !== 0) {
            this.chooseBonusProducts(response.newBonusDiscountLineItem);
        } else {
            var cartURL = document.querySelector('.modal-cart-url').getAttribute('value');

            var htmlString = '<!-- Modal -->'
            + '<div class="modal fade product-added-to-cart-modal" id="addItemToCartModal" tabindex="-1" role="dialog">'
            + '<span class="enter-message sr-only" ></span>'
            + '<div class="modal-dialog modal-lg product-added-to-cart-dialog">'
            + '<!-- Modal content-->'
            + '<div class="modal-content">'
            + '<div class="modal-header">'
            + '<div class="modal-body text-center h3 w-100"><strong>' + response.addedToCartText + '</strong></div>'
            + '    <button type="button" class="close pull-right" data-dismiss="modal">'
            + '        <span aria-hidden="true">&times;</span>'
            + '        <span class="sr-only"> </span>'
            + '    </button>'
            + '</div>'
            + '<div class="modal-footer border-0 justify-content-center">'
            + '<a class="btn add-to-cart btn-primary modal-button" href="' + cartURL + '">' + response.viewCartButtonText + '</a>'
            + '<button class="btn btn-secondary modal-button" data-dismiss="modal" type="button">' + response.continueShoppingText + '</button>'
            + '</div>'
            + '</div>'
            + '</div>'
            + '</div>';

            $('body').append(htmlString);
            $('.modal-body').spinner().start();

            $('#addItemToCartModal').modal('show');
            $.spinner().stop();
        }
    }
}

base.updateAddToCart = function () {
    $('body').on('product:updateAddToCart', function (e, response) {
        var $productContainer = response.$productContainer;
        // update local add to cart (for sets)
        $productContainer.find('button.add-to-cart').attr('disabled',
            (!response.product.readyToOrder || !response.product.available));

        var $addToCartBtn = $productContainer.find('button.add-to-cart');
        if (!response.product.readyToOrder || !response.product.available) {
            $addToCartBtn.attr('disabled', true).attr('aria-label', $addToCartBtn.data('resource-select-attrs'));
        } else {
            $addToCartBtn.attr('disabled', false).attr('aria-label', null);
        }

        // update global add to cart (single products, bundles)
        var $dialog = $(response.$productContainer).closest('.quick-view-dialog');
        if ($dialog.length) {
            $dialog.find('.add-to-cart-global, .update-cart-product-global').attr('disabled',
                !$dialog.find('.global-availability').data('ready-to-order')
                || !$dialog.find('.global-availability').data('available')
            );
        } else {
            var enable = $productContainer.find('.product-availability').toArray().every(function (item) {
                return $(item).data('available') && $(item).data('ready-to-order');
            });
            $productContainer.find('button.add-to-cart-global').attr('disabled', !enable);
        }
    });
};

module.exports = base;
